import React from "react"
import Layout from "../../../common/layout/layout"
import SEO from "../../../common/seo/seo"
import BlogTags from "./components/BlogTags"
import { graphql } from "gatsby"

const BlogTagsTemplate = ({ data, pageContext }) => {
  return (
    <Layout>
      <SEO title={pageContext.title} />
      <BlogTags
        categories={data.categories.edges}
        mostReadBlogs={data.mostReadBlogs.edges}
        data={data.contentfulTags}
      />
    </Layout>
  )
}

export default BlogTagsTemplate

export const pageQuery = graphql`
  query ContentfulBlogTagBySlug($slug: String!) {
    site {
      siteMetadata {
        title
      }
    }
    categories: allContentfulCategories(
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          slug
          name
          order
          contentfulparent {
            name
          }
          categories {
            name
            slug
          }
        }
      }
    }
    mostReadBlogs: allContentfulPosts(
      filter: { node_locale: { eq: "en-US" } }
    ) {
      edges {
        node {
          id
          slug
          title
          timeToRead
          intro {
            content {
              nodeType
              content {
                value
              }
            }
          }
          categories {
            slug
            name
          }
          mainImage {
            fluid(maxWidth: 500, quality: 100) {
              ...GatsbyContentfulFluid_withWebp
            }
          }
          date(formatString: "DD MMMM ")
          author {
            id
            name
            slug
            email
            avatar {
              fluid(maxWidth: 200) {
                ...GatsbyContentfulFluid_withWebp_noBase64
              }
            }
          }
        }
      }
    }
    tags: allContentfulTags(filter: { node_locale: { eq: "en-US" } }) {
      edges {
        node {
          tagName
          id
        }
      }
    }
    contentfulTags(tagName: { eq: $slug }) {
      id
      tagName
      posts {
        id
        title
        slug
        intro {
          content {
            nodeType
            content {
              value
            }
          }
        }
        categories {
          name
          slug
        }
        date(formatString: "DD MMMM YYYY")
        timeToRead
        mainImage {
          fluid(maxWidth: 900, quality: 100) {
            ...GatsbyContentfulFluid_withWebp
          }
        }
        content {
          id
          json
        }
        tags {
          tagName
        }
        author {
          id
          name
          slug
          email
          avatar {
            fluid(maxWidth: 200) {
              ...GatsbyContentfulFluid_withWebp_noBase64
            }
          }
        }
      }
    }
  }
`
